<template>
  <v-card flat color="transparent">
    <v-container>
      <v-card-text>
        <v-row dense>
          <v-col cols="12">
            <v-text-field
              v-model="sucursal.nombre"
              label="Nombre sucursal"
              outlined
              prepend-icon="mdi-home-variant"
              :counter="30"
              name="nombre sucursal"
              autofocus
              v-validate="'required|max:30'"
              :error-messages="errors.collect('nombre sucursal')"
            />
          </v-col>

          <v-col cols="12">
            <v-text-field
              v-model="sucursal.telefono"
              label="Teléfono"
              outlined
              prepend-icon="mdi-phone"
              :counter="30"
              name="telefono"
              v-validate="'required|numeric|min:7|max:30'"
              :error-messages="errors.collect('telefono')"
            />
          </v-col>

          <v-col cols="12">
            <CondicionIvaVSelect :entity="sucursal" />
          </v-col>

          <v-col cols="12">
            <v-text-field
              v-model="sucursal.direccion"
              label="Dirección"
              outlined
              prepend-icon="mdi-map-marker"
              :counter="25"
              name="direccion"
              v-validate="'required|max:25'"
              :error-messages="errors.collect('direccion')"
            />
          </v-col>

          <v-col cols="12">
            <v-text-field
              v-model="sucursal.telegram_chat_id"
              label="Telegram ID"
              outlined
              prepend-icon="mdi-chat"
              :counter="17"
              name="telegram"
              v-validate="'numeric|min:7|max:17'"
              :error-messages="errors.collect('telegram')"
            />
          </v-col>

          <v-col cols="12">
            <v-select
              v-model="id_provincia"
              :items="provincias"
              item-text="nombre"
              item-value="id"
              outlined
              label="Provincia"
              name="provincia"
              v-validate="'required'"
              :error-messages="errors.collect('provincia')"
              @change="fetchLocalidades"
            />
          </v-col>

          <v-col cols="12">
            <v-select
              v-model="sucursal.localidad.id"
              :items="localidades"
              item-text="nombre"
              item-value="id"
              outlined
              label="Localidad"
              name="localidad"
              v-validate="'required'"
              :error-messages="errors.collect('localidad')"
              no-data-text="Sin localidades"
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-row justify="end" class="px-4 pb-3">
          <v-btn
            color="primary"
            class="text-white"
            :loading="loading"
            :disabled="errors.any()"
            @click="validateForm"
          >
            {{ textButton }}
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-container>
  </v-card>
</template>

<script>
import CondicionIvaVSelect from "@/components/util/CondicionIvaVSelect.vue";

export default {
  name: "SucursalForm",

  components: {
    CondicionIvaVSelect,
  },
    $_veeValidate: {
    validator: "new",
  },

  props: {
    sucursal: {
      type: Object,
      required: true,
    },
    provincias: {
      type: Array,
      required: true,
    },
    isUpdate: {
      type: Boolean,
      default: false,
    },
    textButton: {
      type: String,
      default: "Registrar",
    },
  },

  data() {
    return {
      localidades: [],
      id_provincia: null,
      loading: false,
    };
  },

  created() {
    if (this.isUpdate && this.sucursal.localidad) {
      this.id_provincia = this.sucursal.localidad.provincia.id;
      this.fetchLocalidades(this.id_provincia);
    } else {
      this.sucursal.localidad = { id: null };
    }
  },

  methods: {
    async fetchLocalidades(id_prov) {
      try {
        const { data } = await this.axios.get(
          `/soporte/provincias/${id_prov}/localidades`
        );
        this.localidades = data;
      } catch (error) {
        console.error("Error al cargar localidades", error);
        this.$updateBus.$emit("showSnackBar", {
          show: true,
          color: "error",
          text: "No se pudieron cargar las localidades",
        });
      }
    },
    

    validateForm() {
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          this.$emit("process-sucursal", this.sucursal);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
